import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100vh;
  background: #fff8f2;
}

.lucky-page,
.lucky-page * {
  box-sizing: border-box;
}

.lucky-page {
  position: relative;
  display: flex;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 8px;
  background: #fff8f2;
  color: #5f2a3b;
}

.lucky-shell {
  position: relative;
  z-index: 1;
  width: min(430px, 100vw - 16px);
  height: min(884px, 100vh - 16px);
  height: min(884px, 100dvh - 16px);
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 58px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.92), rgba(255, 131, 214, 0.44)), linear-gradient(145deg, #ffc2f5, #f06ab9 45%, #ba70ff);
  box-shadow: 0 26px 58px rgba(87, 32, 101, 0.2), inset 0 0 0 4px rgba(255, 255, 255, 0.58), inset 0 0 28px rgba(131, 45, 157, 0.2);
}

.lucky-shell::before,
.lucky-shell::after {
  position: absolute;
  content: "";
  pointer-events: none;
}

.lucky-shell::before {
  inset: 8px;
  z-index: -1;
  border-radius: 52px;
  background: linear-gradient(180deg, rgba(255, 236, 250, 0.95), rgba(203, 117, 255, 0.28));
}

.lucky-shell::after {
  inset: 17px;
  border: 2px solid rgba(255, 244, 255, 0.82);
  border-radius: 47px;
}

.lucky-screen {
  position: relative;
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border-radius: 46px;
  background: #fff8f2;
  box-shadow: inset 0 0 0 1px rgba(144, 69, 113, 0.14), inset 0 0 34px rgba(255, 142, 196, 0.16);
}

.lucky-screen::before,
.lucky-screen::after {
  position: absolute;
  z-index: 0;
  content: "";
  pointer-events: none;
}

.lucky-screen::before {
  top: 88px;
  left: 22px;
  width: 76px;
  height: 54px;
  border: 3px solid rgba(205, 118, 223, 0.24);
  border-radius: 54% 46% 45% 55%;
  transform: rotate(-15deg);
}

.lucky-screen::after {
  right: 26px;
  top: 158px;
  width: 36px;
  height: 36px;
  border: 2px solid rgba(244, 170, 41, 0.5);
  border-radius: 14px;
  transform: rotate(38deg);
}

.lucky-status {
  position: relative;
  z-index: 2;
  display: flex;
  height: 38px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding-top: 10px;
}

.lucky-speaker {
  width: 70px;
  height: 16px;
  border-radius: 999px;
  background: linear-gradient(180deg, #151218, #37313a);
  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.18);
}

.lucky-camera {
  width: 18px;
  height: 18px;
  border: 3px solid #35303a;
  border-radius: 50%;
  background: #151218;
}

.lucky-header {
  position: relative;
  z-index: 2;
  display: flex;
  min-height: 44px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 4px 20px 0;
}

.lucky-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 34px;
  border: 1px solid rgba(255, 115, 179, 0.46);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  padding: 0 18px;
  color: #f14f9f;
  font-size: 13px;
  font-weight: 1000;
  line-height: 1;
  text-transform: uppercase;
}

.lucky-badge i {
  color: #ff9dcc;
  font-size: 12px;
}

.lucky-menu {
  position: absolute;
  right: 16px;
  top: 8px;
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #fb68ad;
  font-size: 27px;
}

.lucky-content {
  position: relative;
  z-index: 1;
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  padding: 10px 18px 16px;
}

.lucky-hero {
  position: relative;
  flex: 0 0 auto;
  padding-top: 4px;
  text-align: center;
}

.lucky-hero h1 {
  margin: 0;
  color: #fb3f94;
  font-size: 39px;
  font-weight: 1000;
  line-height: 1.08;
  letter-spacing: 0;
  text-shadow: 0 3px 0 #ffffff, 0 8px 18px rgba(218, 72, 159, 0.3);
}

.lucky-hero h1 span,
.lucky-hero h1 strong {
  display: block;
}

.lucky-hero h1 strong {
  color: #8b48dd;
  font-size: 37px;
  font-style: normal;
  -webkit-text-stroke: 1px rgba(255, 255, 255, 0.52);
}

.lucky-hero p {
  margin: 10px 0 0;
  color: #704732;
  font-size: 15px;
  font-weight: 900;
  line-height: 1.48;
}

.lucky-hero-icon {
  position: absolute;
  color: #ff71b2;
  filter: drop-shadow(0 4px 5px rgba(216, 68, 146, 0.2));
}

.lucky-hero-icon-left {
  left: 8px;
  top: 44px;
  font-size: 24px;
  transform: rotate(-13deg);
}

.lucky-hero-icon-right {
  right: 0;
  top: 76px;
  color: #ffc233;
  font-size: 34px;
  transform: rotate(16deg);
}

.lucky-input-panel {
  position: relative;
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  border: 2px solid rgba(252, 185, 218, 0.9);
  border-radius: 26px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.95), rgba(255, 247, 253, 0.9)), #ffffff;
  padding: 20px 18px;
}

.lucky-input-panel.is-loading {
  justify-content: center;
  border-color: rgba(255, 151, 201, 0.72);
  background: #ffe3f1;
}

.lucky-form-state,
.lucky-result-state {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
}

.lucky-panel-title {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  margin-bottom: 16px;
  padding-right: 34px;
  color: #9447df;
  font-size: 24px;
  font-weight: 1000;
  line-height: 1.16;
  letter-spacing: 0;
}

.lucky-panel-title label,
.lucky-panel-title span {
  min-width: 0;
  white-space: nowrap;
}

.lucky-panel-title i:first-child {
  color: #ff70b3;
  font-size: 25px;
}

.lucky-panel-star {
  position: absolute;
  right: 0;
  top: 0;
  color: #ffc33a;
  font-size: 25px;
}

.lucky-textarea,
.lucky-result-box {
  display: block;
  width: 100%;
  min-height: 0;
  flex: 1 1 auto;
  border: 2px solid rgba(199, 121, 220, 0.58);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.82);
  padding: 20px 22px;
  color: #6a4235;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.56;
  outline: none;
}

.lucky-textarea {
  resize: none;
  caret-color: #ff4e9d;
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.lucky-textarea::placeholder {
  color: rgba(106, 66, 53, 0.76);
}

.lucky-textarea:focus {
  border-color: #f35ca6;
  background: #fff;
  box-shadow: 0 0 0 6px rgba(255, 112, 183, 0.16);
}

.lucky-result-box {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  overflow-wrap: break-word;
  word-break: keep-all;
}

.lucky-result-box p {
  margin: 0;
  width: 100%;
  min-width: 0;
  white-space: normal;
  line-break: auto;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.lucky-chip-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}

.lucky-chip {
  min-height: 42px;
  border: 1px solid rgba(186, 92, 219, 0.36);
  border-radius: 999px;
  background: #fff7ff;
  padding: 0 14px;
  color: #8938d2;
  font-size: 13px;
  font-weight: 1000;
  line-height: 1.2;
  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease;
}

.lucky-chip:nth-child(2) {
  border-color: rgba(234, 164, 39, 0.58);
  color: #b96f08;
  background: #fffaf0;
}

.lucky-chip:hover {
  transform: translateY(-1px);
  border-color: rgba(255, 92, 169, 0.64);
  background: #fff;
}

.lucky-action,
.lucky-secondary-action {
  display: flex;
  min-height: 60px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 0;
  border-radius: 25px;
  color: #fff;
  font-size: 23px;
  font-weight: 1000;
  line-height: 1;
  text-shadow: 0 2px 0 rgba(151, 25, 91, 0.24);
  transition: transform 160ms ease, opacity 160ms ease;
}

.lucky-action {
  width: 100%;
  flex: 0 0 auto;
  margin-top: 20px;
  background: linear-gradient(180deg, #ff64b1 0%, #fb2588 100%);
  box-shadow: 0 10px 0 #d51d74;
}

.lucky-action i,
.lucky-secondary-action i {
  color: #fff8bd;
  font-size: 22px;
}

.lucky-action.is-ready:hover,
.lucky-secondary-action:hover {
  transform: translateY(-1px);
}

.lucky-action.is-ready:active,
.lucky-secondary-action:active {
  transform: translateY(4px);
}

.lucky-action.is-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.lucky-result-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 20px;
}

.lucky-secondary-action {
  background: linear-gradient(180deg, #b46cff 0%, #8e41dc 100%);
  box-shadow: 0 8px 0 #6f2ebb;
}

.lucky-share-action {
  background: linear-gradient(180deg, #ff64b1 0%, #fb2588 100%);
  box-shadow: 0 8px 0 #d51d74;
}

.lucky-share-message {
  min-height: 18px;
  margin: 14px 0 0;
  color: #9a3add;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.2;
  text-align: center;
}

.lucky-loading-state {
  display: flex;
  min-height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ff3f91;
  text-align: center;
}

.lucky-loading-star {
  margin-bottom: 22px;
  color: #ffb830;
  font-size: 58px;
  filter: drop-shadow(0 7px 8px rgba(201, 97, 25, 0.16));
}

.lucky-loading-state h2 {
  margin: 0 0 22px;
  font-size: 30px;
  font-weight: 1000;
  line-height: 1.2;
  letter-spacing: 0;
}

.lucky-progress {
  width: min(250px, 82%);
  height: 22px;
  overflow: hidden;
  border: 2px solid rgba(255, 98, 170, 0.48);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: inset 0 2px 5px rgba(157, 37, 97, 0.1);
}

.lucky-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #ff64b1, #ff2a89);
  transition: width 170ms ease;
}

.lucky-loading-state p {
  margin: 16px 0 0;
  color: #9a3add;
  font-size: 26px;
  font-weight: 1000;
  line-height: 1;
}

.lucky-footer {
  display: flex;
  min-height: 28px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #b967d9;
  font-size: 15px;
  font-weight: 1000;
  line-height: 1.2;
  text-align: center;
}

.lucky-footer i {
  color: #f1aa87;
  font-size: 13px;
}

@media (max-width: 520px) {
  .lucky-shell {
    width: calc(100vw - 16px);
    height: calc(100vh - 16px);
    height: calc(100dvh - 16px);
    padding: 8px;
    border-radius: 50px;
  }
  .lucky-shell::before {
    inset: 7px;
    border-radius: 45px;
  }
  .lucky-shell::after {
    inset: 14px;
    border-radius: 41px;
  }
  .lucky-screen {
    border-radius: 40px;
  }
  .lucky-content {
    min-height: 0;
  }
}
@media (max-height: 800px) {
  .lucky-content {
    gap: 12px;
    padding-bottom: 12px;
  }
  .lucky-hero h1 {
    font-size: 35px;
  }
  .lucky-hero h1 strong {
    font-size: 34px;
  }
  .lucky-hero p {
    margin-top: 8px;
    font-size: 14px;
  }
  .lucky-input-panel {
    padding: 17px 18px;
  }
  .lucky-panel-title {
    margin-bottom: 12px;
    font-size: 22px;
  }
  .lucky-textarea,
  .lucky-result-box {
    padding: 16px 18px;
    font-size: 18px;
  }
  .lucky-chip-row,
  .lucky-result-actions {
    margin-top: 14px;
  }
  .lucky-action,
  .lucky-secondary-action {
    min-height: 54px;
    font-size: 21px;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public maxLength: number = 300;
    public inputText: string = '';
    public resultText: string = '';
    public isLoading: boolean = false;
    public progress: number = 0;
    public shareMessage: string = '';

    public async ngOnInit() {
        await this.service.init();
    }

    public onInputChange(value: string) {
        const next = (value || '').slice(0, this.maxLength);
        if (next !== value) {
            this.inputText = next;
        }

        if (!next.trim()) {
            this.resultText = '';
        }
        this.shareMessage = '';
    }

    public async useSample(sample: string) {
        if (this.isLoading) {
            return;
        }

        this.inputText = sample.slice(0, this.maxLength);
        this.resultText = '';
        this.shareMessage = '';
        await this.service.render();
    }

    public async convert() {
        if (this.isLoading) {
            return;
        }

        const source = this.inputText.replace(/\s+/g, ' ').trim();
        if (!source) {
            this.resultText = '';
            this.progress = 0;
            this.shareMessage = '';
            await this.service.render();
            return;
        }

        this.resultText = '';
        this.progress = 0;
        this.isLoading = true;
        this.shareMessage = '';
        await this.service.render();

        const progressTimer = window.setInterval(async () => {
            if (this.progress < 92) {
                this.progress = Math.min(this.progress + 7, 92);
                await this.service.render();
            }
        }, 220);

        let response: any = null;
        try {
            response = await wiz.call("generate", { text: source });
        } catch (error) {
            response = {
                code: 500,
                message: 'AI 답변을 가져오지 못했어. 잠깐 뒤에 다시 시도해줘.'
            };
        } finally {
            window.clearInterval(progressTimer);
        }

        this.progress = 100;
        await this.service.render();
        await this.wait(180);

        if (response.code === 200) {
            this.resultText = response.data?.text || response.data || 'AI 답변이 비어 있었어. 한 번만 다시 눌러줘.';
        } else {
            this.resultText = this.getErrorMessage(response);
        }

        this.isLoading = false;
        await this.service.render();
    }

    private getErrorMessage(response: any) {
        if (typeof response?.data === 'string') {
            return response.data;
        }

        if (response?.data?.message) {
            return response.data.message;
        }

        if (response?.message) {
            return response.message;
        }

        if (response?.responseJSON?.message) {
            return response.responseJSON.message;
        }

        return 'AI 답변을 가져오지 못했어. 잠깐 뒤에 다시 시도해줘.';
    }

    private wait(ms: number) {
        return new Promise<void>((resolve) => setTimeout(resolve, ms));
    }

    private copyWithTextarea(text: string) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', 'true');
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }

    public async reset() {
        this.inputText = '';
        this.resultText = '';
        this.isLoading = false;
        this.progress = 0;
        this.shareMessage = '';
        await this.service.render();
    }

    public async share() {
        const question = this.inputText.trim();
        const result = this.resultText.trim();
        if (!question || !result) {
            return;
        }

        const text = `질문\n${question}\n\n결과\n${result}`;
        const nav = navigator as any;

        try {
            if (nav.share) {
                await nav.share({
                    title: '럭키띵킹 결과',
                    text
                });
                this.shareMessage = '공유 화면을 열었어';
            } else if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text);
                this.shareMessage = '질문과 결과를 복사했어';
            } else {
                this.copyWithTextarea(text);
                this.shareMessage = '질문과 결과를 복사했어';
            }
        } catch (error) {
            if ((error as Error).name !== 'AbortError') {
                this.copyWithTextarea(text);
                this.shareMessage = '질문과 결과를 복사했어';
            }
        }

        await this.service.render();
    }

}

export default PageAccessComponent;